// extracted by mini-css-extract-plugin
module.exports =  {"item":"item-tmgb_","degraded-label":"degraded-label-_q43U"};